import React from 'react';

import { useTagState } from './TagContext';

const TagInfo = () => {
  const state = useTagState();

  return (
    <>
      <p>{`Value: ${state?.tag?.value || ''}`}</p>
      <p>{`Normalized Value: ${state?.tag?.normalizedValue || ''}`}</p>
    </>
  );
};

export default TagInfo;
